/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import {
  Card, CardBody, CardTitle, Container, Row, Col,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { MapContainer, TileLayer } from 'react-leaflet';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form/immutable';
import { connect } from 'react-redux';
import { latLng, latLngBounds } from 'leaflet';
import { LabeledText } from '../LabeledText';
import GeomanControl from './GeomanControl';

const updateFields = (change, bounds) => {
  change('.maxLatitude', bounds ? `${bounds.north}` : '');
  change('.minLongitude', bounds ? `${bounds.west}` : '');
  change('.maxLongitude', bounds ? `${bounds.east}` : '');
  change('.minLatitude', bounds ? `${bounds.south}` : '');
};

const southWest = latLng(-90, -360);
const northEast = latLng(90, 360);
const mapBounds = latLngBounds(southWest, northEast);

const LatLongSearchCardUnwrapped = ({
  helpModalIdPrefix, change, north, south, east, west,
}) => (
  <Card className="haz-inner-card">
    <CardBody>

      <CardTitle>Range of Coordinates in Decimal Degrees</CardTitle>
      <div className="haz-lat-long-form">
        <Container fluid>
          <Row>
            <Col>
              <div className="haz-lat-long-form-row">
                <MapContainer
                  className="haz-lat-long-form-map"
                  center={[0, 0]}
                  zoom={2}
                  scrollWheelZoom={false}
                  maxBounds={mapBounds}
                  maxBoundsViscosity={1.0}
                >
                  <TileLayer
                    attribution="Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri"
                    url="https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                  />
                  <TileLayer
                    attribution="Produced by: United Nations Geospatial Contributor: UNGIS, UNGSC, Field Missions CONTACT US: Your feedback is appreciated and should be sent directly to: Email:Clearmap@un.org / gis@un.org (UNCLASSIFIED) © UNITED NATIONS 2018"
                    url="https://geoservices.un.org/arcgis/rest/services/ClearMap_Imagery/MapServer/tile/{z}/{y}/{x}"
                    maxNativeZoom={6}
                  />
                  <GeomanControl
                    onChange={bounds => updateFields(change, bounds)}
                    north={north ? parseFloat(north) : null}
                    south={south ? parseFloat(south) : null}
                    east={east ? parseFloat(east) : null}
                    west={west ? parseFloat(west) : null}
                  />
                </MapContainer>
              </div>
            </Col>
            <Col md="auto">

              <div className="haz-lat-long-form-row">
                <LabeledText model=".maxLatitude" label="N. Lat." helpModalId={helpModalIdPrefix ? `${helpModalIdPrefix}Latitude` : 'latitude'} />
              </div>
              <div className="haz-lat-long-form-row">
                <LabeledText
                  formGroupClassName={['mr-2']}
                  model=".minLongitude"
                  label="W. Long."
                  helpModalId={helpModalIdPrefix ? `${helpModalIdPrefix}Longitude` : 'longitude'}
                />
                <LabeledText
                  formGroupClassName={['ml-2']}
                  model=".maxLongitude"
                  label="E. Long."
                  helpModalId={helpModalIdPrefix ? `${helpModalIdPrefix}Longitude` : 'longitude'}
                />
              </div>
              <div className="haz-lat-long-form-row">
                <LabeledText model=".minLatitude" label="S. Lat." helpModalId={helpModalIdPrefix ? `${helpModalIdPrefix}Latitude` : 'latitude'} />
              </div>

            </Col>
          </Row>
        </Container>


      </div>
    </CardBody>
  </Card>
);

LatLongSearchCardUnwrapped.propTypes = {
  helpModalIdPrefix: PropTypes.string,
  change: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  model: PropTypes.string.isRequired,
  north: PropTypes.string.isRequired,
  south: PropTypes.string.isRequired,
  east: PropTypes.string.isRequired,
  west: PropTypes.string.isRequired,
};

LatLongSearchCardUnwrapped.defaultProps = {
  helpModalIdPrefix: '',
};

const mapStateToProps = (state, props) => {
  const forms = state.get('forms');
  return {
    north: forms[props.model].maxLatitude.value,
    west: forms[props.model].minLongitude.value,
    east: forms[props.model].maxLongitude.value,
    south: forms[props.model].minLatitude.value,
  };
};

const mapDispatchToProps = (dispatch, props) => bindActionCreators({
  change: (field, value) => actions.change(`${props.model}${field}`, value),
}, dispatch);


export const LatLongSearchCard = connect(mapStateToProps, mapDispatchToProps)(LatLongSearchCardUnwrapped);
